import * as HttpService from "../../../../service/HttpService";

/**
 * 根据用电单位查询配电房
 * @param inputValue input框值
 */
export const queryPowerStationList = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/videoMonitor/queryPowerStationList?inputValue=" + params);
};
/**
 * 查询终端管理列表
*/
export const getVideoList = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/videoMonitor/getVideoList?stationId=" + params);
};
/**
 * 查询终端管理列表
 */
export const videoPlayBack = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/videoMonitor/videoPlayBackByDeviceSerial", params);
};

/**
 * 停止摄像头推流
 */
export const videoStop = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/videoMonitor/videoStop", params);
};

/**
 * 控制摄像头方向
 */
export const controlDirection = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/videoMonitor/hikvisionVideoPlayBackByDeviceSerial", params);
};
/**
 * 获取曲线数据
 */
export const getCurveData = (relMeterId,date) => {
    return HttpService.get(HttpService.DOMAIN + "/videoMonitor/toObtainTheTemperature?relMeterId="+relMeterId+'&date='+date);
};

/**
 * 获取图片
 */
export const getPhoto = (deviceId,channelId) => {
    return HttpService.getPhoto(HttpService.YoloDOMAIN + "/wvpSnapYolov/"+deviceId+"/" +channelId);
};
